module.exports = __webpack_public_path__ + "static/media/specialist.f6fe6d80.svg";